var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMastercard = function SvgMastercard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.667 3.5c0-1.657 1.215-3 2.714-3h26.238c1.5 0 2.714 1.343 2.714 3v18c0 1.657-1.215 3-2.714 3H3.381c-1.499 0-2.714-1.343-2.714-3v-18Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.62 1H3.38c-1.25 0-2.262 1.12-2.262 2.5v18c0 1.38 1.013 2.5 2.262 2.5h26.238c1.25 0 2.262-1.12 2.262-2.5v-18c0-1.38-1.013-2.5-2.262-2.5ZM3.38.5C1.882.5.667 1.843.667 3.5v18c0 1.657 1.215 3 2.714 3h26.238c1.5 0 2.714-1.343 2.714-3v-18c0-1.657-1.215-3-2.714-3H3.381Z",
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.727 17.657c-1.079 1.028-2.477 1.649-4.005 1.649-3.41 0-6.174-3.09-6.174-6.903 0-3.812 2.764-6.903 6.174-6.903 1.528 0 2.927.62 4.005 1.65 1.078-1.03 2.476-1.65 4.005-1.65 3.41 0 6.173 3.09 6.173 6.903 0 3.812-2.764 6.903-6.174 6.903-1.528 0-2.926-.62-4.004-1.65Z",
    fill: "#ED0006"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.727 17.657c1.327-1.266 2.169-3.15 2.169-5.254 0-2.104-.842-3.988-2.17-5.254C17.806 6.121 19.204 5.5 20.732 5.5c3.41 0 6.174 3.09 6.174 6.903 0 3.812-2.764 6.903-6.174 6.903-1.528 0-2.926-.62-4.004-1.65Z",
    fill: "#F9A000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.727 7.15c1.327 1.265 2.169 3.15 2.169 5.253 0 2.104-.842 3.987-2.17 5.254-1.327-1.267-2.168-3.15-2.168-5.254 0-2.104.841-3.988 2.169-5.254Z",
    fill: "#FF5E00"
  })));
};
export default SvgMastercard;